import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo, forwardRef } from "react";
import Icon from "../../Icon/Icon";
var TelegramLogoIcon = /*#__PURE__*/forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.01 12.005c0 5.526-4.48 10.005-10.005 10.005C6.48 22.01 2 17.53 2 12.005 2 6.48 6.48 2 12.005 2 17.531 2 22.01 6.48 22.01 12.005zm-5.234-3.499c.087-.983-.954-.578-.954-.578-.768.317-1.561.64-2.363.966-2.484 1.01-5.05 2.055-7.237 3.082-1.186.434-.492.868-.492.868l1.88.578c.867.26 1.33-.029 1.33-.029l4.048-2.747c1.446-.983 1.1-.173.752.174l-3.036 2.891c-.463.405-.231.752-.029.926.574.504 1.985 1.428 2.6 1.831.161.105.268.175.292.193.144.115.925.636 1.445.52.521-.115.579-.78.579-.78l.694-4.54c.104-.789.223-1.546.319-2.151.09-.572.158-1.007.172-1.204z",
    fill: "currentColor"
  }));
});
export default /*#__PURE__*/memo(TelegramLogoIcon);